export const SET_BALANCE = 'SET_BALANCE'
export const REMOVE_BALANCES = 'REMOVE_BALANCES'
